import React from "react";

export default function FormInlineError({ errorMessage }: { errorMessage: string }) {
    return (
        <p className="text-error text-xs italic">{errorMessage}</p>
    );
}